import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brass';

const tones: Record<Tone, string> = {
  neutral: 'bg-ink-700/60 text-text-muted border-border',
  success: 'bg-success/10 text-success border-success/30',
  warning: 'bg-warning/10 text-warning border-warning/30',
  danger:  'bg-danger/10 text-danger border-danger/30',
  info:    'bg-info/10 text-info border-info/30',
  brass:   'bg-brass-400/10 text-brass-300 border-brass-400/30',
};

type BadgeProps = HTMLAttributes<HTMLSpanElement> & { tone?: Tone };

export function Badge({ className, tone = 'neutral', children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 text-2xs font-medium',
        'uppercase tracking-ultra rounded-sm border',
        tones[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
